<template>
<section >
    <section>

        <swiper
            class="swiper model_slide"
            :options="imgSwiperOption"
        >
            <swiper-slide class="item" v-for="att in atts" :key="`dealer-item-atts-item-${att.id}`">
                <div class="item">
                    <div class="model_img">
                        <img :src="att.url">
                    </div>
                </div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
        </swiper>

        

        <div class="wrap">

            <div class="find_showroom_info">
                <dl class="showroom_info">
                    <dt>
                        {{ dealerItem.name }}
                        <div><img class="brandImg" :src="dealerItem.brandAtt ? dealerItem.brandAtt.url : ''"></div>
                    </dt>
                    <dd>
                        <span>{{ dealerItem.nameEn }}</span>
                    </dd>
                </dl>
            </div>
            <div class="consultant_introduce">
                <h4 class="title">소개</h4>
                <div class="contants">
                    <div class="contants_pbox1">
                        <p class="">
                            {{ dealerItem.content }}
                        </p>
                    </div>
                </div>
            </div>
        </div>                     
    </section>

    <section class="showroom_consultant news_section" v-show="newsShopOnload">

        <div class="wrap">
            <h2 class="section_title">뉴스</h2>
        </div>

        <swiper
            v-show="newsItems.length > 0"
            class="swiper showroom_consultant_ul mh11"
            :options="newsSwiperOption"
        >

            <swiper-slide class="item" 
                v-for="(news, idx) in newsItems" 
                :key="`dealer-info-news-${idx}`"  
            >
                <a class="carousel-shadow" @click="$router.push(`/newsInfo/${news.id}`)">
                    <figure>
                        <img :src="news.boardUrl">
                    </figure>
                    <figcaption class="news_figcaption">
                        <dl class="news_dl">
                            <dt>
                                {{news.title}}
                            </dt>
                            <dd>{{news.startDt}}</dd>
                        </dl>
                    </figcaption>
                </a>
            </swiper-slide>
        </swiper>
    </section>

    <section class="showroom_list" v-show="newsShopOnload">

        <div class="wrap">
            <h2 class="section_title" @click="$router.push(`/dealerShop/${dealerItem.id}`);">
                전시장
                <a><img :src="resource.imgIconArrowRigth"></a>
                <!-- <router-link :to="`/dealerShop/${dealerItem.id}`"><img :src="resource.imgIconArrowRigth"></router-link> -->
            </h2>
        </div>
        
        <swiper
            class="swiper showroom_list_slide mh11"
            :options="shopSwiperOption"
        >
            <swiper-slide class="item" 
                v-for="(shop, idx) in shopItems" 
                :key="`dealer-info-news-${idx}`"  
            >
                <a class="carousel-shadow"  @click="$router.push(`/shopInfo/${shop.id}`)">
                    <figure>
                        <span>{{ getLocationName(shop.sigunguCode) }}</span>
                        <img :src="shop.attUrl ? shop.attUrl : resource.imgSampleShop">
                    </figure>
                    <figcaption class="showroom_name">
                        {{ shop.name }}
                    </figcaption>
                </a>
            </swiper-slide>
        </swiper>

    </section>
</section>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { DateFormatMixin } from '../../mixins/DateFormatMixin';

export default {
    name:'DealerInfo',
    mixins:[DateFormatMixin],
    components:{
    },
    data() {
        return {
            filters: {...this.$store.state.board.filters},
            imgSwiperOption: {
                autoHeight: true, //enable auto height
                pagination: {
                    el: '.swiper-pagination'
                }
            },

            newsSwiperOption: {
                autoHeight: true, //enable auto height
                slidesPerView: 2.4, //화면에 slide 노출 개수
            },

            shopSwiperOption: {
                autoHeight: true, //enable auto height
                slidesPerView: 2.4, //화면에 slide 노출 개수
            },

            newsShopOnload: false,

            atts:[],
        }
    },
    async created () {

        let today = this.dayjsFormat(this.getToday() , 'YYYY-MM-DD');

        this.$store.state.headerBlank = false;

        await this.$store.dispatch('GET_DEALER', this.dealerId)
        .then(() => {
            this.atts = this.viewDealerAtts(this.dealerItem.atts)
            this.$store.commit('SHOW_ONLOAD');
        })
        .catch((e)=>{
            this.$store.commit('SHOW_ONLOAD');
            this.apiCatch(e);
        });

        await this.$store.dispatch('GET_BOARD_LIST', {
            type:this.NEWS_DTYPE_MAIN,
            dealerId: this.dealerId,
            showDt: today
        });

        await this.$store.dispatch('GET_SHOP_LIST', {
            dealerId: this.dealerId,
        });
        
        this.newsShopOnload = true;
    },
    
    computed: {
        ...mapState({
            dealerItem : state => state.dealer.item,
            shopItems : state => state.shop.items,
            newsItems: state => state.board.items,

            SIGUNGU_CODE: state => state.codeDictionary.SIGUNGU_CODE,
            NEWS_DTYPE_MAIN: state => state.codeDictionary.items.BOARD_DTYPE.NEWS.id,

            resource: state => state.resource,
        }),

        ...mapGetters([
            'viewDealerAtts'
        ]),

        dealerId() {
            return this.$route.params.dealerId; 
        }
    },
    methods: {
        getLocationName(code) {
            let substr = code.substr(0, 2);
            let result  = this.SIGUNGU_CODE.find(item => item.id==substr);

            return result ? result.name : "";
        }
    }
    
}
</script>

<style scoped>
</style>